import React, { Fragment } from 'react'
import { Heading } from '~elements'
import { InfoBarSection } from '~modules'
import { Col, Container, Row } from 'react-grid-system'
import styles from './InfoBar.module.scss'
import { useWindowSize } from 'utils/hooks'
import cx from 'classnames'
import { getImageUrl } from 'utils/assets/getImageUrl'
import { InfoBarProps } from '~types'

const InfoBar = ({
  headline,
  infoBarSections,
  highlightedWords,
  gradientColor,
  displayGradient,
  gradientPlacementOnTop,
  image
}: InfoBarProps) => {
  const { isBreakpoint: isBelowSm } = useWindowSize('sm', '<')
  const imageUrl = getImageUrl({ imageUrl: image?.url })

  return (
    <>
      <Container className='container container--narrow-xxl'>
        {displayGradient && gradientPlacementOnTop && (
          <div className={cx(styles[`linear-gradient-top-${gradientColor}`], styles['gradient-height'])}></div>
        )}
        <div className={styles.container} style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}>
          <div className={styles['infobar']}>
            {headline && (
              <Heading level={2} justify='center' noMarginBottom>
                {highlightedWords && <span className={styles['highlight-word']}>{highlightedWords + ' '}</span>}
                {headline}
              </Heading>
            )}
            <Row>
              {infoBarSections &&
                infoBarSections.map((infoBarSection, index) => (
                  <Fragment key={infoBarSection?.id || index}>
                    <Col md={5.5} className={styles['container-padding']}>
                      <InfoBarSection {...infoBarSection} />
                    </Col>
                    {index % 2 === 0 && (
                      <Col md={1} className={styles['margin-auto']}>
                        <div className={isBelowSm ? styles['horizontal-line'] : styles['vertical-line']} />
                      </Col>
                    )}
                  </Fragment>
                ))}
            </Row>
          </div>
        </div>
        {displayGradient && !gradientPlacementOnTop && (
          <div className={cx(styles[`linear-gradient-bottom-${gradientColor}`], styles['gradient-height'])}></div>
        )}
      </Container>
    </>
  )
}

export default InfoBar
